'use strict';

(function($) {

    var pluginName = 'KumsalDatatable';


    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var datatable = this;


        var Plugin = {
            isInit: false,
            method: '',
            url: '',
            columns: [],
            datatableObject: null,
            hasFilters: false,
            filterForm: null,
            filters: [],
            hasActions: false,
            actionForm: null,
            actionType: null,
            selectorIds: [],
            delay: function(callback, ms) {
                var timer = 0;
                return function() {
                    var context = this, args = arguments;
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        callback.apply(context, args);
                    }, ms || 0);
                };
            },
            changeFilters:function(){
                datatable.datatableObject.setDataSourceQuery(datatable.filters);
                datatable.datatableObject.load();
            },
            changeSelector: function (){
                datatable.selectorIds = Array.from(new Set(datatable.selectorIds));

                if(datatable.selectorIds.length)
                {
                    datatable.actionForm.removeClass('d-none');
                    datatable.actionForm.find('.action-button').attr('data-count',datatable.selectorIds.length);
                }
                else
                {
                    if(datatable.actionForm != null)
                    {
                        datatable.actionForm.addClass('d-none');
                    }
                }
            },
            removeSelectors: function()
            {
                datatable.datatableObject.setActiveAll(false);
                datatable.selectorIds = [];
                datatable.changeSelector();

                datatable.datatableObject.reload();
            },
            isNull: function (value){
                return typeof value === "object" && !value
            },
            action:function(form,translate){

                swal.fire({
                    title: translate.title,
                    text: translate.text,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: translate.buttons.confirm,
                    cancelButtonText: translate.buttons.cancel,
                    showLoaderOnConfirm: true,
                    allowOutsideClick: function() {
                        return !swal.isLoading();
                    },
                    preConfirm: function () {
                        return new Promise(function (resolve) {
                            $.ajax({
                                url: $(form).attr('action'),
                                type: $(form).attr('method'),
                                data: $(form).serialize()
                            }).always(function(status) {
                                if(typeof status.status === 'boolean' && status.status)
                                {
                                    swal.fire(
                                        translate.success.title,
                                        translate.success.text,
                                        'success'
                                    );
                                    datatable.removeSelectors();
                                }
                                else
                                {
                                    swal.fire(
                                        _translation.datatable.action.failed.title,
                                        datatable.isNull(status.message) ? _translation.datatable.action.failed.text : status.message,
                                        'error'
                                    );
                                }
                            })
                        })
                    },
                }).then(function(result){

                    if (result.dismiss === 'cancel') {

                        swal.fire(
                            _translation.datatable.action.cancel.title,
                            _translation.datatable.action.cancel.text,
                            'error'
                        );
                    }
                });
            },
            multiAction: function(){

                swal.fire({
                    title: _translation.datatable.action.title,
                    text: _translation.datatable.action.text,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: _translation.datatable.action.buttons.confirm,
                    cancelButtonText: _translation.datatable.action.buttons.cancel,
                    showLoaderOnConfirm: true,
                    allowOutsideClick: function(){
                        return !swal.isLoading();
                    },
                    preConfirm: function () {
                        return new Promise(function (resolve) {
                            $.ajax({
                                url: datatable.actionForm.attr('action'),
                                type: datatable.actionForm.attr('method'),
                                data: {
                                    type: datatable.actionType,
                                    ids: datatable.selectorIds,
                                }
                            }).always(function(status) {
                                if(typeof status.status === 'boolean' && status.status)
                                {
                                    swal.fire(
                                        _translation.datatable.action.success.title,
                                        _translation.datatable.action.success.text,
                                        'success'
                                    );
                                    datatable.removeSelectors();
                                }
                                else
                                {
                                    swal.fire(
                                        _translation.datatable.action.failed.title,
                                        datatable.isNull(status.message) ? _translation.datatable.action.failed.text : status.message,
                                        'error'
                                    );
                                }
                            })
                        })
                    },
                }).then(function(result){

                    if (result.dismiss === 'cancel') {

                        swal.fire(
                            _translation.datatable.action.cancel.title,
                            _translation.datatable.action.cancel.text,
                            'error'
                        );
                    }
                });
            },
            initDatatable : function () {
                datatable.datatableObject = datatable.datatableObject.KTDatatable({
                    // datasource definition
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                method: datatable.method,
                                url: datatable.url,
                                map: function(raw) {
                                    // sample data mapping
                                    var dataSet = raw;
                                    if (typeof raw.data !== 'undefined') {
                                        dataSet = raw.data;
                                    }
                                    return dataSet;
                                },
                                params: {
                                    query: datatable.filters,
                                }
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    // layout definition
                    layout: {
                        scroll: false,
                        footer: false,
                    },

                    // column sorting
                    sortable: true,

                    pagination: true,

                    // columns definition
                    columns: datatable.columns
                });
                datatable.datatableObject.on('kt-datatable--on-layout-updated', function() {
                    KTApp.initTooltips();
                })
            },
            initFormPlugin: function(){
                var arrows;
                if (KTUtil.isRTL()) {
                    arrows = {
                        leftArrow: '<i class="la la-angle-right"></i>',
                        rightArrow: '<i class="la la-angle-left"></i>'
                    }
                } else {
                    arrows = {
                        leftArrow: '<i class="la la-angle-left"></i>',
                        rightArrow: '<i class="la la-angle-right"></i>'
                    }
                }

                datatable.filterForm.find('.input-daterange').datepicker({
                    rtl: KTUtil.isRTL(),
                    todayHighlight: true,
                    templates: arrows,
                    language: '{{ app()->getLocale() }}',
                    todayBtn: "linked",
                    clearBtn: true,
                    format: 'yyyy-mm-dd'
                }).on('changeDate', function(e) {
                    datatable.initFilters();
                    datatable.changeFilters();
                });
            },
            initFilters: function(){
                datatable.filters = [];
                datatable.filterForm.find('.form-control:not(div)').each(function (key,object) {
                    if ($(object).val() !== ''){
                        datatable.filters[key] = $(object).data();
                        delete datatable.filters[key]['selectpicker'];
                        delete datatable.filters[key]['select2Id'];
                        delete datatable.filters[key]['select2'];
                        delete datatable.filters[key]['datepicker'];
                        datatable.filters[key]['value'] = $(object).val();
                    }

                });
                datatable.filters = datatable.filters.filter(Boolean)
            },
            init: function() {

                if (!datatable.isInit)
                {
                    if (datatable.hasFilters)
                    {
                        datatable.initFormPlugin();
                        datatable.initFilters();

                        datatable.filterForm.submit(function (e) {
                            datatable.initFilters();
                            datatable.changeFilters();
                            datatable.find('.kumsal-datatable-filter-class').removeClass('d-none');
                            return false;
                        });

                        datatable.filterForm.find('.kt-select2').change(function () {
                            datatable.initFilters();
                            datatable.changeFilters();
                        });

                        datatable.filterForm.find('input.form-control').keyup(datatable.delay(function (e) {
                            datatable.initFilters();
                            datatable.changeFilters();
                        }, 500));

                        datatable.filterForm.find('button[type=reset]').click(function () {

                            datatable.filterForm[0].reset();
                            datatable.filterForm.find('.kt-select2').trigger('change');
                            datatable.find('.kumsal-datatable-filter-class').addClass('d-none');
                            datatable.initFilters();
                            datatable.changeFilters();
                        });
                    }

                    datatable.initDatatable();

                    datatable.on("submit", ".datatable-delete-form", function(e) {
                        datatable.action(this,_translation.datatable.delete);
                        return false;
                    });

                    datatable.on("submit", ".datatable-restore-form", function(e) {
                        datatable.action(this,_translation.datatable.restore);
                        return false;
                    });

                    datatable.on("submit", ".datatable-force-delete-form", function(e) {
                        datatable.action(this,_translation.datatable.forceDelete);
                        return false;
                    });

                    if (datatable.hasActions)
                    {
                        datatable.datatableObject.on('kt-datatable--on-check', function(e, args) {
                            $.map( Array.isArray(args) ? args : [args], function( val, i ){
                                datatable.selectorIds.push(val);
                            });
                            datatable.changeSelector();
                        });
                        datatable.datatableObject.on('kt-datatable--on-uncheck', function(e, args) {
                            $.map( Array.isArray(args) ? args : [args], function( val, i ){
                                datatable.selectorIds.splice( datatable.selectorIds.indexOf(val),1);
                            });
                            datatable.changeSelector();
                        });
                        datatable.datatableObject.on('kt-datatable--on-layout-updated', function() {
                            $.map( datatable.selectorIds, function( val, i ){
                                datatable.datatableObject.setActive(val);
                            });
                        });
                        datatable.changeSelector();

                        datatable.actionForm.on("click",'.action-button',function(e) {
                            e.preventDefault();
                            datatable.actionType = $(this).attr('data-type');
                            $(this).parents('form').submit();
                            return false;
                        });

                        datatable.actionForm.submit(function(e) {
                            if (datatable.selectorIds.length)
                            {
                                datatable.multiAction();
                            }
                            return false;
                        });
                    }

                    datatable.isInit = true;
                }

                return datatable;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            datatable[funcName] = func;
        });

        if (!datatable.isInit){

            if ($(options.filterForm).length !== 0) {
                datatable.filterForm = $(options.filterForm);
                datatable.hasFilters = true;
            }
            if ($(options.actionForm).length !== 0) {
                datatable.actionForm = $(options.actionForm);
                datatable.hasActions = true;
            }
            datatable.method = options.method;
            datatable.url = options.url;
            datatable.columns = options.columns;
            datatable.datatableObject = $(options.datatable);

            datatable.init();
        }

        return datatable;
    };

    $(document).ready(function () {

        var defaults = {
            translate: {
                records: {
                    processing: _translation.datatable.processing,
                    noRecords: _translation.datatable.noRecords,
                },
                toolbar: {
                    pagination: {
                        items: {
                            default: {
                                first: _translation.datatable.first,
                                prev: _translation.datatable.prev,
                                next: _translation.datatable.next,
                                last: _translation.datatable.last,
                                more: _translation.datatable.more,
                                input: _translation.datatable.input,
                                select: _translation.datatable.selectList,
                            },
                            info: _translation.datatable.info,
                        },
                    },
                },
            },
            toolbar: {
                // place pagination and displayInfo blocks according to the array order
                layout: ['pagination', 'info'],

                // toolbar placement can be at top or bottom or both top and bottom repeated
                placement: ['bottom'],  //'top', 'bottom'

                // toolbar items
                items: {
                    // pagination
                    pagination: {
                        // pagination type(default or scroll)
                        type: 'default',

                        // number of pages to display by breakpoints
                        pages: {
                            desktop: {
                                layout: 'default',
                                pagesNumber: 5,
                            },
                            tablet: {
                                layout: 'default',
                                pagesNumber: 3,
                            },
                            mobile: {
                                layout: 'compact',
                            },
                        },

                        // navigation buttons
                        navigation: {
                            prev: true, // display prev button
                            next: true, // display next button
                            first: true, // display first button
                            last: true, // display last button
                            more: false // display more button
                        },

                        // page size select
                        pageSizeSelect: [10, 20, 30, 50, 100, 200, 500, 1000], // display dropdown to select pagination size. -1 is used for "ALl" option
                    },

                    // records info
                    info: true,
                },
            },
        };

        $.extend(true, $.fn.KTDatatable.defaults, defaults);

    });

}(jQuery));
